<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">礼物名称</span>
        <el-input v-model.trim="giftName" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="pages.page = 1; giftPlatformPageFn()" >
          搜索
        </el-button>
        <el-button type="primary" @click="editBtn(1)" >
          新增
        </el-button>
        <el-button type="primary" @click="editBtn(4)">
          兑换比例
        </el-button>
      </div>
    </el-row>



   <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'" >
      <el-table-column align="center" prop="giftName" label="礼物名称"></el-table-column>
      <el-table-column align="center"  label="礼物图片">
        <template slot-scope="{row}">
          <el-image class="m-box-img" :src="row.giftImg" @click="editBtn(3,row)" lazy></el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="giftPrice" label="购买金额"></el-table-column>
      <el-table-column align="center" prop="exchangeRatio" label="兑换比例"></el-table-column>
      <el-table-column align="center" prop="exchangePrice" label="兑换金额"></el-table-column>
      <el-table-column align="center" prop="giftVotes" label="可加票数"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a" @click="editBtn(6,row)">编辑</a>
          <a class="glob-a" @click="editBtn(7,row)">删除</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>


    <!-- 新增礼物 -->
    <el-dialog :title="t == 1 ? '新增':'编辑' " :visible.sync="giftData.modal" width="500px">
      <el-form label-width="80px">
        <el-form-item label="礼物名称">
          <el-input v-model.trim="giftData.giftName"  placeholder="请输入礼物名称"/>
        </el-form-item>
        <el-form-item label="购买金额">
          <el-input v-model.trim="giftData.giftPrice" type="number" placeholder="请输入购买金额"/>
        </el-form-item>
        <el-form-item label="可加票数">
          <el-input v-model.trim="giftData.giftVotes" type="number" placeholder="请输入可加票数"/>
        </el-form-item>
        <el-form-item label="礼物图片">
          <el-row>
            <more-img class="mr10 mb10" v-model="giftData.giftImg" :total="1"/>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="giftData.modal = false">取 消</el-button>
        <el-button type="primary" @click="t == 1 ? editBtn(2) : editBtn(8)">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 兑换比例 -->
    <el-dialog title="兑换比例" :visible.sync="proportion.modal" width="500px">
      <el-form label-width="80px">
        <el-form-item label="兑换比例">
          <el-input v-model.trim="proportion.exchangeRatio" value="" type="number"  placeholder="请输入兑换比例"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="proportion.modal = false">取 消</el-button>
        <el-button type="primary" @click="editBtn(5)">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 图片放大 -->
    <el-dialog title="查看" :visible.sync="imgPreData.modal" width="800px">
      <img style="width: 100%; height: auto;" :src="imgPreData.url" alt="">
    </el-dialog>

  </div>
</template>

<script>
  import MoreImg from '@/components/MoreImg.vue'
  import {
    giftPlatformPage,
    addGiftPlatform,
    addImage,
    getGiftPlatformExchangeRatio,
    getGiftPlatformExchangeRatioPut,
    editGiftPlatform,
    delGiftPlatform
  } from '@/api'

  export default {
    name: 'GiftList',
    components: {MoreImg},
    data () {
      return {
        //新增礼物
        giftData: {
          platformGiftIdList:[],
          platformGiftId:'',
          giftName:'',
          giftPrice:'',
          giftVotes:'',
          giftImg:[],
          modal: false
        },
        //分成比例
        proportion :{
          modal:false,
          exchangeRatio:0
        },
        tableData: [],
        tableLoading: false,
        //礼物名称
        giftName:'',
        pages: {
          page: 1,
          total: 0
        },
        imgTotal: 1,
        // 图片上传
        imgUploadData: {
          modal: false,
          urlList: []
        },
        // 图片放大
        imgPreData: {
          modal: false,
          url: ''
        },
        t:0
      }
    },
    created(){
     this.giftPlatformPageFn();
    },
    methods: {
      giftPlatformPageFn() {
        this.tableLoading = true
        giftPlatformPage({
          pageNum: this.pages.page,
          giftName: this.giftName
        }).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      },
      //新增平台礼物
      addGiftPlatformFn() {
        addGiftPlatform({
          giftName: this.giftData.giftName,
          giftImg: this.giftData.giftImg[0],
          giftPrice:this.giftData.giftPrice,
          giftVotes:this.giftData.giftVotes
        }).then(res => {
          this.giftData.modal = false
          this.giftPlatformPageFn();
        }).finally(() => {
          this.tableLoading = false
        })
      }, getGiftPlatformExchangeRatioFn(){
            getGiftPlatformExchangeRatio().then(res => {
                this.proportion.exchangeRatio = res.data
            })
        },
        getGiftPlatformExchangeRatioPutFn(){
            getGiftPlatformExchangeRatioPut({
                exchangeRatio:this.proportion.exchangeRatio
            }).then(res => {
                this.proportion.modal = false
            }).finally(() => {
                this.tableLoading = false
            })
        },
      editGiftPlatformFn(){
        editGiftPlatform({
          platformGiftId:this.giftData.platformGiftId,
          giftName:this.giftData.giftName,
          giftImg:this.giftData.giftImg,
          giftPrice:this.giftData.giftPrice,
          giftVotes:this.giftData.giftVotes
        }).then(res => {
          this.proportion.modal = false
          this.giftPlatformPageFn();
        }).finally(() => {
          this.tableLoading = false
        })
      },
      delGiftPlatformFn(){
        delGiftPlatform({
          platformGiftIdList:this.giftData.platformGiftIdList
        }).then(res => {
          this.proportion.modal = false
          this.giftPlatformPageFn();
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange(val) {
        this.pages.page = val
        this.getUserVPageFn()
      },
      //t = 1新增礼物弹出框 2保存礼物 3放大图片 4比例兑换查看 5比例兑换修改 6列表编辑查看 7删除 8礼物编辑
      editBtn(t,row) {
        if (t == 1) {
          this.giftData={modal:true,giftImg:[]}
        } else if(t == 2){
        this.addGiftPlatformFn();
        } else if (t == 3) {
          this.imgPreData = {
            modal: true,
            url: row.giftImg
          }
        }else if(t == 4){
          this.getGiftPlatformExchangeRatioFn();
          this.proportion.modal = true
        }else if(t == 5){
            this.getGiftPlatformExchangeRatioPutFn();
        }else if(t == 6){
          this.giftData = {modal:true, giftName:row.giftName, giftPrice:row.giftPrice, giftVotes:row.giftVotes, giftImg:[row.giftImg]}
        }else if(t == 7){
            this.$confirm(`确认要删除吗`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.giftData = {platformGiftIdList:[row.platformGiftId]}
              this.delGiftPlatformFn();
          });
        }else if(t == 8){
        this.editGiftPlatformFn();
        }
        this.t = t
      },
      uploadSave() {
        if (this.imgUploadData.urlList && this.imgUploadData.urlList.length) {
          addImage(this.imgUploadData.urlList.map(item => ({pictureUrl: item}))).then(res => {
            this.$message.success(res.data)
            this.imgUploadData.modal = false
            this.getImagePageFn()
          })
        }
      }
    }
  }
</script>
